import { useEffect, useState } from "react";

const links = [
  { href: "#home", label: "首页" },
  { href: "#collections", label: "热门合集" },
  { href: "#categories", label: "内容分类" },
  { href: "#rants", label: "神吐槽" },
  { href: "#memes", label: "梗图段子" },
  { href: "#faq", label: "常见问题" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-background-50/95 backdrop-blur shadow-sm" : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6">
        <a href="#home" className="flex items-center gap-2 whitespace-nowrap">
          <span className="grid h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-xl text-background-50">
            <i className="ri-emotion-laugh-line"></i>
          </span>
          <span className="font-heading text-xl text-foreground-950">
            韩国歪歪漫画
          </span>
        </a>

        <ul className="hidden items-center gap-1 md:flex">
          {links.map((l) => (
            <li key={l.href}>
              <a
                href={l.href}
                className="rounded-full px-4 py-2 text-sm text-foreground-700 transition-colors hover:bg-primary-100 hover:text-primary-700"
              >
                {l.label}
              </a>
            </li>
          ))}
          <li>
            <a
              href="#contact"
              className="ml-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2 text-sm text-background-50 transition-colors hover:bg-primary-600"
            >
              订阅更新
            </a>
          </li>
        </ul>

        <button
          type="button"
          aria-label="展开菜单"
          onClick={() => setOpen((v) => !v)}
          className="grid h-10 w-10 items-center justify-center rounded-lg bg-secondary-100 text-foreground-900 md:hidden"
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`}></i>
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-4 md:hidden">
          <ul className="flex flex-col gap-1">
            {links.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="block rounded-lg px-4 py-3 text-sm text-foreground-800 hover:bg-primary-100"
                >
                  {l.label}
                </a>
              </li>
            ))}
            <li>
              <a
                href="#contact"
                onClick={() => setOpen(false)}
                className="mt-1 block rounded-full bg-primary-500 px-5 py-3 text-center text-sm text-background-50"
              >
                订阅更新
              </a>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}